'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alignToClassName = {
  left: "dp-LevelLeft",
  right: "dp-LevelRight",
  top: "dp-LevelTop",
  bottom: "dp-LevelBottom",
  auto: "dp-Level"
};

/**
 * @param {string} [align]
 * @param {string} [className]
 * @param {*} [children]
 * @return {*}
 * @constructor
 */
var Level = function Level(_ref) {
  var align = _ref.align,
      className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(alignToClassName[align], className) },
    children
  );
};

Level.propTypes = {

  className: _propTypes2.default.string,

  align: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom', 'auto'])
};

Level.defaultProps = {
  align: "auto"
};

exports.default = Level;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/Layout/Level.js
// module id = 336
// module chunks = 0